import { memo, type PropsWithChildren } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { useSettings } from "hooks";

const Settings = ({ children }: PropsWithChildren) => {
    const { getSettings } = useSettings();

    if (!getSettings()) {
        return (
            <Box
                sx={{
                    display: "grid",
                    placeContent: "center",
                    height: "100vh"
                }}
            >
                <CircularProgress size={40} />
            </Box>
        );
    }

    return <>{children}</>;
};

export default memo(Settings);
